export const AG_CONTROL_TABLE_LABELS = {
  LOADING: 'Loading controls...',
  CLEAR_SELECTION_TO_GROUP: 'Clear selected controls to group by scope',
} as const

export const CONTROL_COLUMN_HEADERS = {
  CONTROL: 'Control',
  SCOPE: 'Scope',
  WEIGHT: 'Weight',
  CATEGORY: 'Category',
  CONTROL_ADHERENCE: 'Control adherence',
  VALIDATION_STATUS: 'Validation status',
  GAPS: 'Gaps',
  SMART_EVIDENCE_REQUEST: 'Smart evidence request',
} as const
